import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/auth/RouteGuard";

export const Route = createFileRoute("/_authenticated/disposals")({
  component: () => (
    <RouteGuard module="disposals"><Outlet /></RouteGuard>
  ),
});
